import React, { useState } from 'react';

// Libs
import Swal from 'sweetalert2';

// DTO's
import { DtoResRetrieveBranding } from '../../Dto/DtosHome/DtosITT/DtosResponse/DtoResponseRetrieveBranding';
import { DtoReqRegistrarBranding } from '../../Dto/DtosHome/DtosITT/DtosRequest/DtoRequestRegistrarBranding';
import { DtoResRegistrarBranding } from '../../Dto/DtosHome/DtosITT/DtosResponse/DtoResponseRegistrarBranding';

// Features
import { getUser } from '../FeatureGlobal';
import ApiRegisterBranding from '../../Api/ApiHome/ApiRegisterBranding';
import ApiRetrieveBranding from '../../Api/ApiHome/ApiRetrieveBranding';
import ApiUpdateBranding from '../../Api/ApiHome/ApiUpdateBranding';
import { DtoCurriculumFile } from '../../Dto/DtosHome/DtoCurriculum/DtoCurriculum';

export const FeatureRegisterBranding = () => {
    const [requestDtoRegistrarBranding, setRequestDto] = useState(DtoReqRegistrarBranding());
    const [respondeDtoRetrieveBrandig, setRespondeDtoRetrieveBrandig] = useState(DtoResRetrieveBranding());
    const [responseDtoRegistrarBranding, setResponseDto] = useState(DtoResRegistrarBranding);
    const [loading, setLoading] = useState(false);
    const [photoUser, setPhotoUser] = useState(DtoCurriculumFile);
    const [uploadingImage, setUploadingImage] = useState(false);

    const UpdateBranding = async (id) => {
        setLoading(true);
        requestDtoRegistrarBranding.idUsuario = getUser().idUsuario;

        const result = await ApiUpdateBranding(id, requestDtoRegistrarBranding);

        if (result.hasOwnProperty('codigo')) {
            setResponseDto(result);
        } else if (result.hasOwnProperty('status')) {
            Swal.fire({
                title: 'Ops!',
                text: result.data.Message,
                customClass: {
                    confirmButton: "button_confirm",
                    closeButton: "button_close_modal",
                },
                confirmButtonText: "Cerrar",
            });
        }
        setLoading(false);

    }

    const RetrieveBranding = async () => {
        setLoading(true);

        ApiRetrieveBranding(getUser().idUsuario)
            .then((succ) => {
                if (!!succ && succ.data) {
                    setRespondeDtoRetrieveBrandig(succ.data.empresa);
                    setRequestDto({ ...succ.data.empresa, identidadDigital: succ.data.branding.identidadDigital})
                } else if (succ.hasOwnProperty('status') && succ.status == 404) {
                    setRespondeDtoRetrieveBrandig({ ...respondeDtoRetrieveBrandig, codigo: -1 })
                }
                setLoading(false);
            })
            .catch((e) => {
                Swal.fire({
                    title: e.Message,
                    customClass:{
                      title:'Error'
                    }
                  });
                setLoading(false);
            })
    }

    const RegisterBranding = async () => {
        setLoading(true);
        requestDtoRegistrarBranding.idUsuario = getUser().idUsuario;
        
        ApiRegisterBranding(requestDtoRegistrarBranding)
            .then((succ) => {
                if (succ.hasOwnProperty('codigo')) {
                    setResponseDto(succ);
                } else if (succ.hasOwnProperty('status')) {
                    Swal.fire({
                        title: 'Ops!',
                        text: succ.data.Message,
                        customClass: {
                            confirmButton: "button_confirm",
                            closeButton: "button_close_modal",
                        },
                        confirmButtonText: "Cerrar",
                    });
                }
                setLoading(false);
            })
            .catch((e) => {
                Swal.fire({
                    title: e.Message,
                    customClass:{
                      title:'Error'
                    }
                  });
                setLoading(false);
            })
    };

    const handleInputChange = (value, campo) => {
        setRequestDto({
            ...requestDtoRegistrarBranding,
            [campo]: value
        });
    };

    const handleInputChangeIdentidad = (value, campo) => {
        let actualValues = JSON.parse(requestDtoRegistrarBranding.identidadDigital);
        actualValues[campo] = value;
        let stringValues = JSON.stringify(actualValues);

        setRequestDto({
            ...requestDtoRegistrarBranding,
            identidadDigital: stringValues
        })
    }

    const resizeBase64Img = (base64,width, height) => {
        return new Promise((resolve, reject)=>{
            let canvas = document.createElement("canvas");
            canvas.width = 300;
            const newHeight = (height*300)/width
            canvas.height = newHeight;
            let context = canvas.getContext("2d");
            let img = document.createElement("img");
            img.onload = function () {
                context.drawImage(img, 0, 0,300,newHeight); 
                resolve(canvas.toDataURL());               
            }
            img.src = base64;
        });
    };

    const getImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };
            img.onerror = (error) => {
                reject(error);
            };
            img.src = URL.createObjectURL(file);
        });
    };

    const handlePhotoCurriculum = async (e) => {
        let nameFileImg = e.target.files[0].type;
        photoUser.tipoArchivo = "imagen";
        photoUser.formatoImg = nameFileImg.split("/")[1];
        let file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        const dimensions = await getImageDimensions(file);
        let reader = new FileReader();
        reader.onload = () => _handleReaderLoaded(reader.result,dimensions.width, dimensions.height);
        reader.readAsDataURL(file);
        requestDtoRegistrarBranding.nombreArchivo = e.target.files[0].name;
    };

    const _handleReaderLoaded = (e,width,height) => {
        resizeBase64Img(e,width,height).then(resized=>{
            let img = document.createElement("img");
            img.src = resized;
            setRequestDto(prevState => (
                {
                    ...prevState,
                    rutaImagen: resized.split("base64,")[1]
                }
            ));
            setUploadingImage(true);
        });
        
    };

    return {
        loading,
        respondeDtoRetrieveBrandig,
        requestDtoRegistrarBranding,
        responseDtoRegistrarBranding,
        uploadingImage,
        handleInputChangeIdentidad,
        handlePhotoCurriculum,
        handleInputChange,
        RetrieveBranding,
        RegisterBranding,
        UpdateBranding,
    }

}

export default FeatureRegisterBranding;